export default "__VITE_ASSET__CpbqeUdl__"